/*
 * @author: xd
 * @Date: 2021-12-15 13:00:52
 * @LastEditors: xd
 * @LastEditTime: 2022-02-21 18:19:08
 * @Description: 用户登录信息类
 */

import { Cache } from "../../utils/cache";
import { BaseClass } from "../../base/DreamScape";
// export namespace User {
//   type Options = {
//     width?: number;
//     color?: string ;
//     colorHidden?: string ;
//     showPlane?: boolean;
//     planeAngle?: number;
//     glow?: boolean;
//     glowPower?: number;
//     glowStrength?: number;
//     onlySelected?: boolean;
// };

/**
 * @description: 用户登录信息类
 * @param {*}
 * @return {*}
 */
export class UserInfo extends BaseClass {
  constructor() {
    super();
  }
  /**
   * @description: 获取当前登录用户名
   */
  GetUserName(): string {
    return Cache.GetCookieName("mUserName");
  }

  /**
   * @description: 获取cookie用户ID
   * @param {*}
   * @return {*}
   */
  GetUserID(): string {
    return Cache.GetCookieName("mUserID");
  }

  /**
   * @description: 获取当前项目编号
   * @param {*}
   * @return {*}
   */
  GetSysXmbh(): string {
    return Cache.GetCookieName("xmbh");
  }

  SetSysXmbh(xmbh: string) {
    Cache.SetCookie("xmbh", xmbh, "h8");
  }

  /**
   * @description: 获取token
   * @param {*}
   * @return {*}
   */
  GetSysToken(): string {
    return Cache.GetCookieName("sytoken");
  }

  SetLocalStorageJson(name: string, json: any) {
    Cache.SetLocalStorageJson(name, json);
  }

  GetLocalStorageJson(name: string): any {
    return Cache.GetLocalStorageJson(name);
  }

  SetLocalStorageString(name: string, val: string) {
    Cache.SetLocalStorageString(name, val);
  }

  GetLocalStorageString(name: string): any {
    return Cache.GetLocalStorageString(name);
  }

  RemoveLocalStorageItem(name: string): any {
    localStorage.removeItem(name);
  }
}
// }
